import React from 'react';
import Tab, { TabOption } from './reusable/Tab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * @typedef {Object} Props
 * @property {Array<Object>} options
 * @property {function} onChange
 * @property {string} name
 * @property {string} [inputType]
 *
 * @param {Props} param0
 */
const Tabs = ({ name, value, options, onChange, inputType, defaultValue }) => {
    // eslint-disable-next-line eqeqeq
    const selected = value == undefined ? defaultValue : value;
    return (
        <Tab
            name={name}
            className="tab"
            type={inputType}
            selected={selected}
            onSelect={onChange}
        >
            {options.map((opt, index) => (
                <TabOption key={index} value={opt.value}>
                    {opt.icon ? (
                        <FontAwesomeIcon
                            className="icon"
                            icon={opt.icon.split(' ')}
                        />
                    ) : null}
                    {opt.label}
                </TabOption>
            ))}
        </Tab>
    );
};
export default React.memo(Tabs);
